import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/4e99eeda-f62f-4cdf-a91f-34dff9d059dd";
export const REGISTER_URL = "https://a.ntrk2.com/af2b50f1-c1ec-4ee6-8d17-df6418e69f77";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://gobrwin.loadprkw2a.com/download?openExternalBrowser=1&id=pnwz2mc5o97uc6q";

export * from "./codes";
export * from "./context";
